import CardsBlock from './CardsBlock';

export default CardsBlock;
